/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import {
    Box,
    Stack,
    TextField,
    Button,
    MenuItem,
    Grid,
    Typography,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    IconButton,
    Autocomplete,
    List,
    ListItem,
    ListItemText,
    InputAdornment,
    Divider,
    Checkbox
} from '@mui/material';
import { ArrowForward, AddCircleOutline, CheckRounded, CloseRounded, HighlightOff, ArrowDropDown } from '@mui/icons-material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { IconAdjustmentsHorizontal } from '@tabler/icons';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import MainCard from 'ui-component/cards/MainCard';
import { useUnload } from 'hooks/useUnload';
import RequiredIndicator from 'views/common/RequiredIndicator';
import GlobalDialog from 'views/common/GlobalDialog';
import GlobalDrawer from 'views/common/GlobalDrawer';
import ObjectSelect from 'views/common/ObjectSelect';
import NoObjectMessage from 'views/common/NoObjectMessage';
import DragIcon from 'views/common/DragIcon';
import { LabelStyle, ButtonIconStyle } from 'views/common/ControlsStyle';
import AddContainerDialog from 'views/common/AddContainerDialog';
import Preview from 'views/common/Preview';
import AddObject from './AddObject';
import RandomSettingsBox from './RandomSettingsBox';
import { createContainer, getContainer, getContainerTypes, updateContainer, getChapterTypes } from 'services/ContainerService';
import { getAssignmentFilters, getContainerFilters } from 'services/SearchService';
import { getLevelTagList, getTagList } from 'services/TagService';
import { getProductBasedCategory, getProductCategoriesList } from 'services/ProductService';
import { Container, ContainerObject, RandomSetting, ChapterItem, pointObject } from 'types/container';
import { TagData } from 'types/tag';
import { TypeItem } from 'types/question';
import { RequestParams } from 'types/pagination';
import { ProductCategory } from 'types/product';
import binIcon from 'assets/images/icons/Bin.svg';
import { PencilWritingIcon, SettingsIcon } from 'utils/Icons';
import TextMask from 'react-text-mask';
import { openSnackbar } from 'store/slices/snackbar';
import { useDispatch } from 'store';
import { ReactComponent as CloseIcon } from '../../../assets/images/icons/wrongCheck.svg';
import { ReactComponent as CheckIcon } from '../../../assets/images/icons/Checkborder.svg';
import { ReactComponent as Pencil } from '../../../assets/images/icons/Container-Vector.svg';
import { getAssignmentFilter } from 'services/AssignmentService';
import AddPreviewOnlineTest from 'views/common/AddPreviewOnlineTest';
// import { ReactComponent as CloseIcon } from '../../../assets/images/icons/wrongCheck.svg';

const initialContainer: Container = {
    type_id: 0,
    name: '',
    title: '',
    practice_type: 'arranged',
    display_name: '',
    // tags: {
    //     main: [],
    //     subtheme: []
    // },
    level_tags: [],
    tags: [],
    products: [],
    objects: [],
    exampoint: [],
    m_score: 0,
    n_score: 0,
    product_category_id: null,
    beginner_level_of_student: 0,
    change_factor: 0
};

function AddContainer() {
    const { id } = useParams();
    const [title, setTitle] = useState<string>('add-new-container');
    const [valueStatus, setValueStatus] = useState<number>(0); // 1: Data received, 2: Data changed in local, 0: None received
    const [disabledSave, setDisabledSave] = useState(true);
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    const [disabledProductCategory, setDisabledProductCategory] = useState(false);

    const [container, setContainer] = useState<Container>(initialContainer);
    const [containerTypes, setContainerTypes] = useState<TypeItem[]>([]);
    const [chapterTypes, setChapterTypes] = useState<ChapterItem[]>([]);
    const [tags, setTags] = useState<TagData[]>([]);
    const [levelTags, setLevelTags] = useState<TagData[]>([]);
    const [, setSecondaryTags] = useState<TagData[]>([]);
    const [productCategories, setProductCategories] = useState<ProductCategory[]>([]);
    const [, setProduct] = useState<any>([]);
    const [objects, setObjects] = useState<ContainerObject[]>([]);

    const [exampoint, setExampoint] = useState<pointObject[]>([]);
    const [randomSettings, setRandomSettings] = useState<RandomSetting[]>([]);
    const [openRandom, setOpenRandom] = useState<boolean>(false);
    const [openAdd, setOpenAdd] = useState<boolean>(false);
    const [disableInSingleQuestion, setdisableInSingleQuestion] = useState(false);
    const [isRandom, setIsRandom] = useState(false);
    const [isExamChapter, setIsExamChapter] = useState(false);
    const [isOnlineTest, setIsOnlinetest] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [openPreview, setOpenPreview] = useState<boolean>(false);
    const [openOnlineTestPreview, setOpenOnlinetestPreview] = useState<boolean>(false);
    const [isSetCondition, setisCondition] = useState<boolean>(false);
    const [totalScore, setTotalScore] = useState<number>(0);
    const [currentId, setCurrentId] = useState<string>('');
    const [previewType, setPreviewType] = useState<string>('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [stackId, setStackId] = useState<number>(0);
    const [isCheckIcon, setCheckIcon] = useState<boolean>(false);
    const [requestParams, setRequestParams] = useState<RequestParams>({
        page: 1,
        per_page: 10,
        sort: [{ field: 'active', sort: 'desc' }],
        filters: []
    });
    const [searchParams] = useSearchParams();
    const clone = searchParams.get('clone');
    const intl = useIntl();
    const [open, setOpen] = useState<boolean>(false);
    const timeMask = [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/];
    const dispatch = useDispatch();

    useEffect(() => {
        const style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = `.rtl-ic9pcn-MuiStack-root > :not(style) + :not(style) { margin-right: 0px !important; margin-left: 15px }`;
        document.head.appendChild(style);

        // Correct cleanup function: returns void and properly removes the style element
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    useEffect(() => {
        getContainerTypes(setContainerTypes);
        getProductCategoriesList(setProductCategories);
        getChapterTypes(setChapterTypes);
    }, []);

    useEffect(() => {
        if (id) {
            setTitle('edit-container');
            getContainer(id, setContainer, setObjects, setExampoint, setRandomSettings, setDisabledProductCategory).then(() => {
                setIsLoading(false);
            });
        }
    }, [id]);

    useEffect(() => {
        if (!openAdd && objects.length > 0) {
            if (exampoint.length > 0) {
                const examObj = exampoint.slice(0, objects.length);
                setExampoint(examObj);
            } else {
                const renderedItems = [];
                for (let index = 0; index <= objects.length; index += 1) {
                    const newItem = {
                        number_of_correct_question: index,
                        point: 0
                    };
                    renderedItems.push(newItem);
                }
                setExampoint(renderedItems);
            }
        }
    }, [openAdd]);

    useEffect(() => {
        if (container.product_category_id) {
            getProductBasedCategory(container.product_category_id, setProduct);
            // getTags(setTags, container.product_category_id);
            getTagList(setTags, container.product_category_id);
            getLevelTagList(setLevelTags, container.product_category_id);
            if (container.type_id == 10 || container.type_id == 11) {
                getAssignmentFilters(Number(container.product_category_id)).then((filters: []) =>
                    setRequestParams((prev: RequestParams) => ({ ...prev, filters }))
                );
            } else {
                getContainerFilters(undefined, container.product_category_id).then((filters: []) =>
                    setRequestParams((prev: RequestParams) => ({ ...prev, filters }))
                );
            }
        } else {
            setTags([]);
            setLevelTags([]);
            setSecondaryTags([]);
            setContainer((prevState) => ({ ...prevState, tags: [] }));
        }
    }, [container.product_category_id, container.type_id]);

    useEffect(() => {
        if (!isLoading) {
            setIsRandom(container.practice_type === 'random');
        }
        // eslint-disable-next-line
    }, [isLoading]);

    useEffect(() => {
        /* eslint-disable no-debugger */

        const allObjectsValid = objects.every(
            (obj) =>
                obj.first_container_id !== undefined &&
                obj.first_level !== '' &&
                obj.second_container_id !== undefined &&
                obj.second_level !== '' &&
                obj.third_container_id !== undefined
        );

        const isTimeInvalid =
            container.type_id !== 10 &&
            container.type_id !== 11 &&
            container.type_id !== 1 &&
            !!container.time &&
            container.time !== '00:00' &&
            container.time !== '00:00:00';

        if (
            (container.type_id === 1 ||
                container.type_id === 2 ||
                container.type_id === 4 ||
                (container.type_id === 5 && container.chapter_id !== undefined) ||
                (container.type_id === 6 && totalScore === 100) ||
                ((container.type_id === 10 || container.type_id === 11) &&
                    container.chapter_id !== undefined &&
                    objects.length !== 0 &&
                    allObjectsValid)) &&
            container.display_name !== '' &&
            container.title !== '' &&
            container.product_category_id !== null &&
            (container.type_id == 1 ||
                container.type_id === 5 ||
                container.type_id == 4 ||
                container.type_id == 11 ||
                container.type_id == 10 ||
                isTimeInvalid)
        ) {
            setDisabledSave(false);
        } else {
            setDisabledSave(true);
        }
    }, [container, id, objects, totalScore]);

    useEffect(() => {
        if (container.type_id === 5) {
            setIsExamChapter(true);
        } else {
            setIsExamChapter(false);
        }
        if (container.type_id === 10 || container.type_id === 11) {
            setIsOnlinetest(true);
        } else {
            setIsOnlinetest(false);
        }
    }, [container.type_id]);

    useEffect(() => {
        if (container.name !== '' && valueStatus < 1) setValueStatus(1);
        if (valueStatus === 1) setValueStatus(2);
        if (isRandom) {
            setdisableInSingleQuestion([0].includes(container.type_id));
        } else {
            setdisableInSingleQuestion([0, 1].includes(container.type_id));
        }
    }, [container, valueStatus]);

    useEffect(() => {
        if (success !== undefined && success === true) navigate('/containers');
        // eslint-disable-next-line
    }, [success]);

    useUnload((e: any) => {
        const confirmationMessage = 'Are you sure?/';
        (e || window.event).returnValue = confirmationMessage;
        return confirmationMessage;
    }, valueStatus === 2);
    const submitHandler = async () => {
        if (isSubmitting) {
            // If an API call is already in progress, return early
            return;
        }

        setIsSubmitting(true);

        try {
            const newContainer: Container = { ...container };

            newContainer.objects = objects;

            if (newContainer.type_id === 10 || newContainer.type_id === 11) {
                const data = newContainer.objects.map((item: any) => {
                    if (item.isEdited) {
                        delete item.isEdited;
                    }
                    return item; // Ensure the modified item is returned
                });
            }
            if (isRandom) {
                const randomObj: any = {
                    difficulty_level_from: 0,
                    difficulty_level_to: 0,
                    amount_questions: null,
                    questions_type: null,
                    collections_type: null,
                    // units_type: null
                    main_tags: null,
                    sub_tags: null,
                    start_date: null,
                    end_date: null
                };

                const map: { [key: string]: string } = {
                    amountQuestions: 'amount_questions',
                    difficultyLevelFrom: 'difficulty_level_from',
                    difficultyLevelTo: 'difficulty_level_to',
                    questionType: 'questions_type',
                    collectionType: 'collections_type',
                    // unitType: 'units_type',
                    mainTag: 'main_tags',
                    subTag: 'sub_tags',
                    startDate: 'start_date',
                    endDate: 'end_date'
                };

                randomSettings.forEach(({ name, value }) => {
                    const prop = map[name];
                    if (prop) {
                        randomObj[prop] = value;
                    }
                });

                newContainer.random_settings = randomObj;
            }

            /* newContainer.type_id = 5 is 'Chapter on exam' container_type */
            if (newContainer.type_id == 5) {
                const Chapter = chapterTypes.filter((o) => o.id === newContainer.chapter_id);
                const chapterName = Chapter[0].name;
                const chapterQuestion = Chapter[0].number_of_questions;

                if (chapterQuestion) {
                    if (chapterQuestion != newContainer.objects.length) {
                        const errorMessage = intl.formatMessage(
                            { id: 'number-question-error-message' },
                            { name: chapterName, numberofquestion: chapterQuestion }
                        );
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: errorMessage,
                                variant: 'alert',
                                alert: {
                                    color: 'error'
                                },
                                close: false
                            })
                        );

                        return;
                    }
                }
                newContainer.exampoint = exampoint;
            }

            if (id && !clone) {
                await updateContainer(newContainer, setSuccess, (code) => {
                    if (code != 200 || code != 201) {
                        setIsSubmitting(false);
                    }
                });
            } else {
                delete newContainer.id;
                await createContainer(newContainer, setSuccess, (code) => {
                    if (code != 200 || code != 201) {
                        setIsSubmitting(false);
                    }
                });
            }
        } catch (error) {
            console.error('error', error);
        }
    };

    const handlePracticeTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setContainer({ ...container, practice_type: e.target.value });
        setIsRandom(e.target.value === 'random');
        if (e.target.value === 'random') {
            setOpen(true);
        }
    };
    const handleAddCondition = (selectedstackId: any) => {
        setStackId(selectedstackId);
    };
    const handleOnlinetestPreview = () => {
        setOpenOnlinetestPreview(true);
    };

    const handleCloseIcon = (index: number, item: any) => {
        setStackId(0);
        const newObjects = objects.map((itemData, idx) => {
            if (idx === index) {
                // Assigning new values to each property separately
                itemData.first_container_id = 0;
                itemData.first_level = '';
                itemData.second_container_id = 0;
                itemData.second_level = '';
                itemData.third_container_id = 0;

                // Return the updated object
                return { ...itemData, isEdited: false };
            }
            return itemData;
        });
        setObjects(newObjects);
    };
    const handleClickCheckIcon = (index: any, item: any, itemId: any) => {
        setStackId(itemId);
        const newObjects = objects.map((itemofObject: any, idx: any) => {
            if (idx === index) {
                return { ...itemofObject, isEdited: true };
            }
            return itemofObject;
        });

        newObjects.forEach((obj: any) => {
            if (!obj.selected_container_id) {
                obj.selected_container_id = obj.container_id;
                // delete obj.container_id;
            }
        });

        setObjects(newObjects);
        setStackId(0);
    };
    const handleChangeCheckBox = (e: any) => {
        if (e.target.checked) {
            setisCondition(true);
        } else {
            setisCondition(false);
        }
    };

    const handleOptionChange = () => {
        setOpenAdd(true);
    };

    const handleDeleteObject = (deletedItem: ContainerObject) => {
        const newContainerObjects = objects.filter((item) => item.id !== deletedItem.id);
        setObjects(newContainerObjects);
        const examObj = exampoint.slice(0, objects.length);
        setExampoint(examObj);
    };
    const handleUpdateContainerCondition = (ConditionupdateId: any) => {
        setStackId(ConditionupdateId);
    };

    const handleUpdateObject = (e: any, currentItem: ContainerObject) => {
        const newItem = container.type_id === 6 ? { ...currentItem, points: e.target.value } : { ...currentItem, time: e.target.value };
        const newObjects = objects.map((item) => (item.id === newItem.id ? newItem : item));
        setObjects(newObjects);

        if (container.type_id === 6) {
            const sumPoints = newObjects.reduce((sum, item) => {
                if (item.points === undefined) {
                    return sum;
                }
                return sum + Number(item.points);
            }, 0);

            setTotalScore(sumPoints);
        }
    };

    function handleOnDragEnd(result: any) {
        if (!result.destination) return;
        const items = [...objects];
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        const orderedItems = updateOrder(items);
        setObjects(orderedItems);
    }

    function updateOrder(items: ContainerObject[]) {
        // Reorder the values of the order property
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < items.length; i++) {
            items[i].priority = i + 1;
        }
        return items;
    }
    const handleOpenDailoag = (itemId: string) => {
        setCurrentId(itemId);
        setOpenPreview(true);
    };
    const getGenericDisplayName = (object: ContainerObject): string =>
        intl.formatMessage({
            // eslint-disable-next-line no-nested-ternary
            id: typeof object.type === 'object' ? 'question' : object.type ? object.type : object.collection_id ? 'container' : 'question'
        });

    const getGenericDisplayNameForOnlineTest = (object: ContainerObject): string =>
        object.type === 'container' ? `${object.type} ${object.container_id}` : `${object.type} ${object.unit_id}`;

    function objectSection() {
        return (
            <>
                {!isExamChapter && (
                    <Grid item xs={12}>
                        <DragDropContext onDragEnd={handleOnDragEnd}>
                            <Droppable droppableId="questions">
                                {(provided) => (
                                    <List
                                        sx={{
                                            minHeight: 100
                                        }}
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                    >
                                        {objects.map((item, index) => (
                                            <Draggable key={item?.id} draggableId={String(index)} index={index}>
                                                {(draggablePprovided) => (
                                                    <ListItem
                                                        alignItems="center"
                                                        ref={draggablePprovided.innerRef}
                                                        {...draggablePprovided.draggableProps}
                                                        {...draggablePprovided.dragHandleProps}
                                                    >
                                                        <Stack direction="row" spacing={2} alignItems="center" width="100%">
                                                            <Box
                                                                sx={{
                                                                    color: 'primary.main',
                                                                    border: '1px solid #9E9E9E',
                                                                    borderRadius: '10px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    padding: '14px 10px 4px 8px'
                                                                }}
                                                            >
                                                                <DragIcon />
                                                            </Box>
                                                            <ListItemText sx={{ mx: 1 }}>.{index + 1}</ListItemText>
                                                            <TextField
                                                                disabled
                                                                value={`${getGenericDisplayName(item)} ${
                                                                    item.collection_id ? item.collection_id : item.question_id
                                                                }`}
                                                                variant="outlined"
                                                                sx={{ width: '10rem' }}
                                                            />
                                                            <Box width="8rem">
                                                                <Typography>
                                                                    <FormattedMessage id="object-type" />
                                                                </Typography>
                                                                <Typography>
                                                                    {item.main_tag ? item?.main_tag : ''}
                                                                    {/* <FormattedMessage id={item?.main_tag} /> */}
                                                                </Typography>
                                                            </Box>
                                                            {container.type_id !== 2 && (
                                                                // <TextField
                                                                //     value={container.type_id === 6 ? item.points : item.time}
                                                                //     variant="outlined"
                                                                //     label={
                                                                //         <FormattedMessage id={container.type_id === 6 ? 'score' : 'time'} />
                                                                //     }
                                                                //     onChange={(e) => handleUpdateObject(e, item)}
                                                                //     sx={{ maxWidth: '8.5rem' }}
                                                                // />
                                                                <>
                                                                    {container.type_id === 6 ? (
                                                                        <TextField
                                                                            value={item.points}
                                                                            variant="outlined"
                                                                            label={<FormattedMessage id="score" />}
                                                                            onChange={(e) => handleUpdateObject(e, item)}
                                                                            sx={{ maxWidth: '8.5rem' }}
                                                                        />
                                                                    ) : (
                                                                        <>
                                                                            <FormControl>
                                                                                <FormLabel id="type-buttons-group-label">
                                                                                    <FormattedMessage id="time" />
                                                                                </FormLabel>
                                                                                <TextMask
                                                                                    mask={timeMask}
                                                                                    guide={false} // Set to true if you want to show placeholders while typing
                                                                                    value={item.time || '00:00:00'}
                                                                                    onChange={(e) => handleUpdateObject(e, item)}
                                                                                    style={{
                                                                                        height: '40px',
                                                                                        background: '#fafafa',
                                                                                        borderRadius: '8px'
                                                                                    }}
                                                                                />
                                                                            </FormControl>
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                            <Box sx={{ display: 'flex' }}>
                                                                <IconButton
                                                                    aria-label="clear"
                                                                    color="inherit"
                                                                    component="label"
                                                                    onClick={() => {
                                                                        if (item.type === 'collection') {
                                                                            handleOpenDailoag(String(item.collection_id));
                                                                            setPreviewType('collection');
                                                                        } else {
                                                                            handleOpenDailoag(String(item.question_id));
                                                                            setPreviewType('question');
                                                                        }
                                                                    }}
                                                                >
                                                                    <VisibilityOutlinedIcon sx={{ color: '#7A49B9' }} />
                                                                </IconButton>
                                                                <IconButton
                                                                    aria-label="clear"
                                                                    color="inherit"
                                                                    component="label"
                                                                    onClick={() => handleDeleteObject(item)}
                                                                >
                                                                    <img src={binIcon} alt="delete icon" />
                                                                </IconButton>
                                                            </Box>
                                                        </Stack>
                                                    </ListItem>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </List>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </Grid>
                )}
                {isExamChapter && (
                    <Grid
                        container
                        sx={{
                            overflow: 'auto',
                            height: 550,
                            transform: 'scaleX(-1)',
                            '::-webkit-scrollbar': {
                                width: '0.75rem'
                            },
                            '::-webkit-scrollbar-track': {
                                backgroundColor: '#E4DBF0',
                                borderRadius: '0.625rem'
                            },
                            '::-webkit-scrollbar-button:vertical:start:decrement,::-webkit-scrollbar-button:vertical:end:increment': {
                                display: 'none'
                            },
                            '::-webkit-scrollbar-thumb': {
                                backgroundColor: '#7A49B9',
                                borderRadius: '0.625rem'
                            }
                        }}
                    >
                        <Grid item xs={5} sx={{ backgroundColor: '#F7F4FB', pt: 2.5, px: 1.25, transform: 'scaleX(-1)' }}>
                            <Box sx={{ pb: 2.5 }}>
                                <Typography sx={{ color: 'black' }}>
                                    <FormattedMessage id="chapter-score-title" />
                                </Typography>
                                <Typography sx={{ fontSize: 12, color: '#878E95' }}>
                                    <FormattedMessage id="chapter-score-subtitle" />
                                </Typography>
                            </Box>

                            {/* <List
                                component="ol"
                                dense
                                sx={{ display: 'flex', flexFlow: 'column wrap', gap: '0 30px', height: '100%', overflow: 'hidden' }}
                            >
                                {objects.map((item, index) => (
                                    <ListItem sx={{ px: 0, width: 'auto' }}>
                                        <ListItemText sx={{ ml: 0, mr: 2 }}>.{index + 1}</ListItemText>
                                        <TextField
                                            type="number"
                                            inputProps={{ min: 0, max: 20, step: 1 }}
                                            value={item.points || 0}
                                            label={<FormattedMessage id="score" />}
                                            variant="outlined"
                                            fullWidth
                                            onChange={(e) => {
                                                const newItem = {
                                                    ...item,
                                                    points: Number(e.target.value)
                                                };
                                                setObjects(objects.map((obj) => (obj === item ? newItem : obj)));
                                            }}
                                        />
                                    </ListItem>
                                ))}
                            </List> */}
                            <List
                                component="ol"
                                dense
                                sx={{ display: 'flex', flexFlow: 'column wrap', gap: '0 30px', height: '100%', overflow: 'hidden' }}
                            >
                                {exampoint.map((item, index) => (
                                    <ListItem sx={{ px: 0, width: 'auto' }}>
                                        <ListItemText sx={{ ml: 0, mr: 2 }}>.{index}</ListItemText>
                                        <TextField
                                            type="number"
                                            inputProps={{ min: 0, max: 20, step: 1 }}
                                            value={item.point || 0}
                                            label={<FormattedMessage id="score" />}
                                            variant="outlined"
                                            fullWidth
                                            onChange={(e) => {
                                                const newItem = {
                                                    ...item,
                                                    point: Number(e.target.value)
                                                };
                                                setExampoint(exampoint.map((obj) => (obj === item ? newItem : obj)));
                                            }}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>

                        <Grid item xs={7} sx={{ transform: 'scaleX(-1)' }}>
                            <DragDropContext onDragEnd={handleOnDragEnd}>
                                <Droppable droppableId="questions">
                                    {(provided) => (
                                        <List
                                            sx={{
                                                minHeight: 100
                                            }}
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                        >
                                            {objects.map((item, index) => (
                                                <Draggable
                                                    key={item.id}
                                                    draggableId={
                                                        item.collection_id ? `coll-${item.collection_id}` : `que-${item.question_id}`
                                                    }
                                                    index={index}
                                                >
                                                    {(draggablePprovided) => (
                                                        <>
                                                            <ListItem
                                                                alignItems="center"
                                                                ref={draggablePprovided.innerRef}
                                                                {...draggablePprovided.draggableProps}
                                                                {...draggablePprovided.dragHandleProps}
                                                                sx={{ pr: 0 }}
                                                            >
                                                                <Stack direction="row" spacing={2} alignItems="center" width="100%">
                                                                    <Box
                                                                        sx={{
                                                                            color: 'primary.main',
                                                                            border: '1px solid #9E9E9E',
                                                                            borderRadius: '10px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            padding: '14px 10px 4px 8px'
                                                                        }}
                                                                    >
                                                                        <DragIcon />
                                                                    </Box>
                                                                    <ListItemText sx={{ mx: 2 }}>.{index + 1}</ListItemText>
                                                                    <TextField
                                                                        disabled
                                                                        // value={`${getGenericDisplayName(item)} ${
                                                                        //     item.collection_id ? item.collection_id : item.question_id
                                                                        value={`${item.question_number || ''} ${item.exam_name || ''}`}
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        InputProps={{
                                                                            endAdornment: (
                                                                                <InputAdornment position="start">
                                                                                    <IconButton
                                                                                        aria-label="edit"
                                                                                        color="primary"
                                                                                        onClick={() => handleOptionChange()}
                                                                                    >
                                                                                        <IconAdjustmentsHorizontal />
                                                                                    </IconButton>
                                                                                </InputAdornment>
                                                                            )
                                                                        }}
                                                                    />
                                                                    <Box>
                                                                        <IconButton
                                                                            aria-label="clear"
                                                                            color="inherit"
                                                                            component="label"
                                                                            onClick={() => handleDeleteObject(item)}
                                                                        >
                                                                            <img src={binIcon} alt="delete icon" />
                                                                        </IconButton>
                                                                    </Box>
                                                                </Stack>
                                                            </ListItem>
                                                            <Divider />
                                                        </>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </List>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </Grid>
                    </Grid>
                )}
            </>
        );
    }

    function objectSectionOnlineTest() {
        return (
            <>
                {isOnlineTest && (
                    <Grid item xs={12}>
                        <DragDropContext onDragEnd={handleOnDragEnd}>
                            <Droppable droppableId="questions">
                                {(provided) => (
                                    <List
                                        sx={{
                                            minHeight: 100,
                                            overflowX: 'auto'
                                        }}
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                    >
                                        {objects.map((item, index) => (
                                            <Draggable key={index} index={index} draggableId={String(index)}>
                                                {(draggablePprovided) => (
                                                    <ListItem
                                                        alignItems="center"
                                                        ref={draggablePprovided.innerRef}
                                                        {...draggablePprovided.draggableProps}
                                                        {...draggablePprovided.dragHandleProps}
                                                    >
                                                        {/* eslint-disable no-nested-ternary */}
                                                        {stackId === item.container_id || stackId === item.selected_container_id ? (
                                                            <>
                                                                <Stack
                                                                    sx={{
                                                                        background: '#E4DBF0',
                                                                        maxWidth: item.isEdited ? '1510px' : '100%',
                                                                        padding: '12px 10px 12px 10px'
                                                                    }}
                                                                    direction="row"
                                                                    spacing={2}
                                                                    alignItems="center"
                                                                >
                                                                    <Typography
                                                                        sx={{
                                                                            color: 'primary.main',
                                                                            display: 'flex',
                                                                            alignItems: 'center'
                                                                        }}
                                                                    >
                                                                        {item.selected_container
                                                                            ? item.selected_container?.display_name
                                                                            : item.display_name}
                                                                    </Typography>
                                                                    <TextField
                                                                        value={item.first_container_id}
                                                                        select
                                                                        size="small"
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        onChange={(e) => {
                                                                            const newValue = e.target.value;
                                                                            // Create a new array with all previous items, but update the current one
                                                                            setObjects(
                                                                                objects.map((innerItem: any, innerIndex: any) => {
                                                                                    if (innerIndex === index) {
                                                                                        return {
                                                                                            ...innerItem,
                                                                                            first_container_id: Number(newValue)
                                                                                        };
                                                                                    }
                                                                                    return innerItem;
                                                                                })
                                                                            );
                                                                        }}
                                                                        label={intl.formatMessage({ id: 'choice' })}
                                                                    >
                                                                        {objects.map(
                                                                            (containerDetails: any, containerDetailsindex: any) => (
                                                                                <MenuItem
                                                                                    key={containerDetailsindex}
                                                                                    sx={{ color: '#7A49B9' }}
                                                                                    value={
                                                                                        containerDetails.selected_container
                                                                                            ? containerDetails.selected_container_id
                                                                                            : containerDetails.container_id ||
                                                                                              containerDetails.first_container_id
                                                                                    }
                                                                                >
                                                                                    {containerDetails.selected_container
                                                                                        ? containerDetails.selected_container.title
                                                                                        : containerDetails.display_name}
                                                                                </MenuItem>
                                                                            )
                                                                        )}
                                                                        <MenuItem
                                                                            key="finish-exam"
                                                                            sx={{ color: '#7A49B9' }}
                                                                            value={0} // Setting the value to 0 when "Finish Exam" is selected
                                                                        >
                                                                            <FormattedMessage id="finish-exam" />
                                                                        </MenuItem>
                                                                    </TextField>
                                                                    <TextField
                                                                        value={item.first_level || ''}
                                                                        variant="outlined"
                                                                        size="small"
                                                                        sx={{ width: '20em' }} // fixes the width at 200px
                                                                        onChange={(e) => {
                                                                            const newValue = e.target.value;
                                                                            // Create a new array with all previous items, but update the current one
                                                                            const isValid = /^(?:\d{1,3}(?:\.\d{0,2})?)?$/.test(newValue);
                                                                            if (isValid) {
                                                                                setObjects(
                                                                                    objects.map((innerItem, innerIndex) => {
                                                                                        if (innerIndex === index) {
                                                                                            return {
                                                                                                ...innerItem,
                                                                                                first_level: newValue
                                                                                            };
                                                                                        }
                                                                                        return innerItem;
                                                                                    })
                                                                                );
                                                                            }
                                                                        }}
                                                                    />
                                                                    <TextField
                                                                        size="small"
                                                                        value={item.second_container_id}
                                                                        select
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        label={intl.formatMessage({ id: 'choice' })}
                                                                        onChange={(e) => {
                                                                            const newValue = e.target.value;
                                                                            // Create a new array with all previous items, but update the current one
                                                                            setObjects(
                                                                                objects.map((innerItem, innerIndex) => {
                                                                                    if (innerIndex === index) {
                                                                                        return {
                                                                                            ...innerItem,
                                                                                            second_container_id: Number(newValue)
                                                                                        };
                                                                                    }
                                                                                    return innerItem;
                                                                                })
                                                                            );
                                                                        }}
                                                                    >
                                                                        {objects.map(
                                                                            (containerDetails: any, containerDetailsindex: any) => (
                                                                                <MenuItem
                                                                                    key={containerDetailsindex}
                                                                                    sx={{ color: '#7A49B9' }}
                                                                                    value={
                                                                                        containerDetails.selected_container
                                                                                            ? containerDetails.selected_container_id
                                                                                            : containerDetails.container_id ||
                                                                                              containerDetails.second_container_id
                                                                                    }
                                                                                >
                                                                                    {containerDetails.selected_container
                                                                                        ? containerDetails.selected_container.title
                                                                                        : containerDetails.display_name}
                                                                                </MenuItem>
                                                                            )
                                                                        )}
                                                                        <MenuItem
                                                                            key="finish-exam"
                                                                            sx={{ color: '#7A49B9' }}
                                                                            value={0} // Setting the value to 0 when "Finish Exam" is selected
                                                                        >
                                                                            <FormattedMessage id="finish-exam" />
                                                                        </MenuItem>
                                                                    </TextField>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        value={item.second_level}
                                                                        size="small"
                                                                        sx={{ width: '20em' }} // fixes the width at 200px
                                                                        onChange={(e) => {
                                                                            const newValue = e.target.value;
                                                                            // Create a new array with all previous items, but update the current one
                                                                            const isValid = /^(?:\d{1,3}(?:\.\d{0,2})?)?$/.test(newValue);
                                                                            if (isValid) {
                                                                                setObjects(
                                                                                    objects.map((innerItem, innerIndex) => {
                                                                                        if (innerIndex === index) {
                                                                                            return {
                                                                                                ...innerItem,
                                                                                                second_level: newValue
                                                                                            };
                                                                                        }
                                                                                        return innerItem;
                                                                                    })
                                                                                );
                                                                            }
                                                                        }}
                                                                    />{' '}
                                                                    <TextField
                                                                        size="small"
                                                                        select
                                                                        fullWidth
                                                                        value={item.third_container_id}
                                                                        variant="outlined"
                                                                        label={intl.formatMessage({ id: 'choice' })}
                                                                        onChange={(e) => {
                                                                            const newValue = e.target.value;
                                                                            // Create a new array with all previous items, but update the current one
                                                                            setObjects(
                                                                                objects.map((innerItem, innerIndex) => {
                                                                                    if (innerIndex === index) {
                                                                                        return {
                                                                                            ...innerItem,
                                                                                            third_container_id: Number(newValue)
                                                                                        };
                                                                                    }
                                                                                    return innerItem;
                                                                                })
                                                                            );
                                                                        }}
                                                                    >
                                                                        {objects.map(
                                                                            (containerDetails: any, containerDetailsindex: any) => (
                                                                                <MenuItem
                                                                                    key={containerDetailsindex}
                                                                                    sx={{ color: '#7A49B9' }}
                                                                                    value={
                                                                                        containerDetails.selected_container
                                                                                            ? containerDetails.selected_container_id
                                                                                            : containerDetails.container_id ||
                                                                                              containerDetails.third_container_id
                                                                                    }
                                                                                >
                                                                                    {containerDetails.selected_container
                                                                                        ? containerDetails.selected_container.title
                                                                                        : containerDetails.display_name}
                                                                                </MenuItem>
                                                                            )
                                                                        )}
                                                                        <MenuItem
                                                                            key="finish-exam"
                                                                            sx={{ color: '#7A49B9' }}
                                                                            value={0} // Setting the value to 0 when "Finish Exam" is selected
                                                                        >
                                                                            <FormattedMessage id="finish-exam" />
                                                                        </MenuItem>
                                                                    </TextField>
                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                        <IconButton
                                                                            onClick={() =>
                                                                                handleClickCheckIcon(
                                                                                    index,
                                                                                    item,
                                                                                    item.collection_id || item.question_id
                                                                                )
                                                                            }
                                                                            sx={{
                                                                                border: '1px solid #7A49B9',
                                                                                borderRadius: '3px',
                                                                                padding: '5px',
                                                                                height: '25px',
                                                                                width: '25px'
                                                                            }}
                                                                        >
                                                                            <CheckIcon />
                                                                        </IconButton>
                                                                        <IconButton
                                                                            onClick={() => handleCloseIcon(index, item)}
                                                                            sx={{
                                                                                border: '1px solid #7A49B9',
                                                                                borderRadius: '3px',
                                                                                padding: '5px',
                                                                                height: '25px',
                                                                                width: '25px'
                                                                            }}
                                                                        >
                                                                            <CloseIcon />
                                                                        </IconButton>
                                                                    </Box>
                                                                </Stack>
                                                            </>
                                                        ) : item.isEdited ? (
                                                            <>
                                                                <Stack
                                                                    sx={{
                                                                        opacity: !isSetCondition || stackId ? 0.5 : 1,
                                                                        pointerEvents: !isSetCondition || stackId ? 'none' : 'auto',
                                                                        background: '#fff',
                                                                        color: '#E4DBF0',
                                                                        padding: '12px 10px 12px 10px',
                                                                        marginTop: '-17px',
                                                                        borderTop: '1px solid #E4DBF0',
                                                                        ':hover': {
                                                                            background: '#E4DBF0',
                                                                            color: '#F7F4FB'
                                                                        }
                                                                    }}
                                                                    direction="row"
                                                                    spacing={2}
                                                                    alignItems="center"
                                                                >
                                                                    <Box
                                                                        sx={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            gap: '10px'
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            sx={{
                                                                                color: 'primary.main',
                                                                                border: '1px solid #9E9E9E',
                                                                                borderRadius: '10px',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                padding: '14px 10px 4px 8px'
                                                                            }}
                                                                        >
                                                                            <DragIcon />
                                                                        </Box>
                                                                        <Box sx={{ display: 'flex', gap: '0.5vw', alignItems: 'center' }}>
                                                                            <Box
                                                                                sx={{
                                                                                    width: '4vw',
                                                                                    display: 'flex',
                                                                                    justifyContent: 'flex-start'
                                                                                    // marginLeft: '1vw'
                                                                                }}
                                                                            >
                                                                                <Typography
                                                                                    sx={{
                                                                                        color: '#222529'
                                                                                    }}
                                                                                >
                                                                                    {item.selected_container_id}
                                                                                </Typography>
                                                                            </Box>
                                                                            <Box
                                                                                sx={{
                                                                                    width: '5vw',
                                                                                    wordBreak: 'break-word',
                                                                                    display: 'flex',
                                                                                    justifyContent: 'flex-start'
                                                                                    // marginRight: '20px !important'
                                                                                }}
                                                                            >
                                                                                <Typography
                                                                                    sx={{
                                                                                        color: '#222529'
                                                                                    }}
                                                                                >
                                                                                    {item.selected_container
                                                                                        ? item.selected_container?.display_name
                                                                                        : item.display_name}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Box>
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'flex-end',
                                                                                justifyContent: 'center',
                                                                                gap: item.isEdited ? '0.5vw' : '50px',
                                                                                color: '#7A49B9',
                                                                                fontSize: '12px',
                                                                                fontWeight: '400',
                                                                                marginRight: 'auto',
                                                                                width: '100%'
                                                                            }}
                                                                        >
                                                                            <Box
                                                                                sx={{
                                                                                    display: 'flex',
                                                                                    wordBreak: 'break-word',
                                                                                    flexDirection: 'column',
                                                                                    width: item.isEdited ? '4vw' : '256px'
                                                                                }}
                                                                            >
                                                                                <Typography sx={{ color: '#222529' }}>
                                                                                    <FormattedMessage id="continuation-condition" />
                                                                                </Typography>
                                                                                <Typography>
                                                                                    {item.first_container_id === 0 ? (
                                                                                        <FormattedMessage id="finish-exam" />
                                                                                    ) : item.selected_container ? (
                                                                                        objects.find(
                                                                                            (obj) =>
                                                                                                obj.selected_container_id ===
                                                                                                item.first_container_id
                                                                                        )?.selected_container?.title
                                                                                    ) : (
                                                                                        objects.find(
                                                                                            (obj) =>
                                                                                                obj.selected_container_id ===
                                                                                                item.first_container_id
                                                                                        )?.display_name
                                                                                    )}
                                                                                </Typography>
                                                                            </Box>

                                                                            <Typography sx={{ width: item.isEdited ? '4vw' : '70px' }}>
                                                                                {item.first_level}
                                                                            </Typography>
                                                                            <Typography
                                                                                sx={{
                                                                                    width: '4vw',
                                                                                    wordBreak: 'break-word'
                                                                                }}
                                                                            >
                                                                                {item.second_container_id === 0 ? (
                                                                                    <FormattedMessage id="finish-exam" />
                                                                                ) : item.selected_container ? (
                                                                                    objects.find(
                                                                                        (obj) =>
                                                                                            obj.selected_container_id ===
                                                                                            item.second_container_id
                                                                                    )?.selected_container?.title
                                                                                ) : (
                                                                                    objects.find(
                                                                                        (obj) =>
                                                                                            obj.selected_container_id ===
                                                                                            item.second_container_id
                                                                                    )?.display_name
                                                                                )}
                                                                            </Typography>

                                                                            <Typography sx={{ width: item.isEdited ? '4vw' : '70px' }}>
                                                                                {item.second_level}
                                                                            </Typography>
                                                                            <Typography
                                                                                sx={{
                                                                                    width: item.isEdited ? '4vw' : '256px',
                                                                                    wordBreak: 'break-word'
                                                                                }}
                                                                            >
                                                                                {item.third_container_id === 0 ? (
                                                                                    <FormattedMessage id="finish-exam" />
                                                                                ) : item.selected_container ? (
                                                                                    objects.find(
                                                                                        (obj) =>
                                                                                            obj.selected_container_id ===
                                                                                            item.third_container_id
                                                                                    )?.selected_container?.title
                                                                                ) : (
                                                                                    objects.find(
                                                                                        (obj) =>
                                                                                            obj.selected_container_id ===
                                                                                            item.third_container_id
                                                                                    )?.display_name
                                                                                )}
                                                                            </Typography>
                                                                        </Box>

                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'flex-end',
                                                                                // gap: '10px',
                                                                                marginLeft: '0.5vw',
                                                                                marginRight: 'auto',
                                                                                '.rtl-ic9pcn-MuiStack-root > :not(style) + :not(style)': {
                                                                                    margin: 0,
                                                                                    marginRight: '0px !important' // Use !important to force override
                                                                                }
                                                                            }}
                                                                        >
                                                                            <IconButton
                                                                                onClick={() =>
                                                                                    handleUpdateContainerCondition(
                                                                                        item.selected_container
                                                                                            ? item.selected_container_id
                                                                                            : item.container_id
                                                                                    )
                                                                                }
                                                                            >
                                                                                <Pencil />
                                                                            </IconButton>
                                                                            <IconButton
                                                                                aria-label="clear"
                                                                                component="label"
                                                                                sx={{
                                                                                    marginRight: 'auto'
                                                                                }}
                                                                                onClick={() => handleDeleteObject(item)}
                                                                            >
                                                                                <img src={binIcon} alt="delete icon" />
                                                                            </IconButton>
                                                                        </Box>
                                                                    </Box>
                                                                </Stack>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Stack
                                                                    direction="row"
                                                                    spacing={2}
                                                                    alignItems="center"
                                                                    width="100%"
                                                                    sx={{
                                                                        opacity: !isSetCondition || stackId ? 0.5 : 1,
                                                                        pointerEvents: !isSetCondition || stackId ? 'none' : 'auto' // Disables interaction
                                                                    }}
                                                                >
                                                                    <Box
                                                                        sx={{
                                                                            color: 'primary.main',
                                                                            border: '1px solid #9E9E9E',
                                                                            borderRadius: '10px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            padding: '14px 10px 4px 8px'
                                                                        }}
                                                                    >
                                                                        <DragIcon />
                                                                    </Box>
                                                                    <ListItemText sx={{ mx: 1 }}>.{index + 1}</ListItemText>
                                                                    <TextField
                                                                        fullWidth
                                                                        disabled
                                                                        value={
                                                                            item.selected_container
                                                                                ? item.selected_container.display_name
                                                                                : item.display_name !== ''
                                                                                ? item.display_name
                                                                                : getGenericDisplayNameForOnlineTest(item)
                                                                        }
                                                                        variant="outlined"
                                                                        InputProps={{
                                                                            endAdornment: (
                                                                                <InputAdornment position="start">
                                                                                    <IconButton
                                                                                        aria-label="edit"
                                                                                        color="primary"
                                                                                        onClick={() => handleOptionChange()}
                                                                                    >
                                                                                        <IconAdjustmentsHorizontal />
                                                                                    </IconButton>
                                                                                </InputAdornment>
                                                                            )
                                                                        }}
                                                                        // sx={{ width: '8rem' }}
                                                                    />
                                                                    <Box>
                                                                        <IconButton onClick={() => handleAddCondition(item.container_id)}>
                                                                            <AddCircleOutline fontSize="small" sx={{ color: '#7A49B9' }} />
                                                                        </IconButton>
                                                                    </Box>
                                                                    <Box width="8rem">
                                                                        <Typography sx={{ color: '#7A49B9', width: '10rem' }}>
                                                                            <FormattedMessage id="addtion-of-continuation-conditions" />
                                                                        </Typography>

                                                                        <Typography>
                                                                            {item.main_tag ? item?.main_tag : ''}
                                                                            {/* <FormattedMessage id={item?.main_tag} /> */}
                                                                        </Typography>
                                                                    </Box>

                                                                    <Box sx={{ display: 'flex' }}>
                                                                        <IconButton
                                                                            aria-label="clear"
                                                                            color="inherit"
                                                                            component="label"
                                                                            onClick={() => handleDeleteObject(item)}
                                                                        >
                                                                            <img src={binIcon} alt="delete icon" />
                                                                        </IconButton>
                                                                    </Box>
                                                                </Stack>
                                                            </>
                                                        )}

                                                        {/* {item.isEdited && (
                                                            
                                                        )} */}
                                                    </ListItem>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </List>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </Grid>
                )}
            </>
        );
    }
    return (
        <Box component="form" noValidate>
            <MainCard title={<FormattedMessage id={title} />}>
                <Grid container spacing={2}>
                    <Grid item container xs={6} spacing={2} alignContent="flex-start">
                        <Grid item xs={12}>
                            <MainCard title={<FormattedMessage id="container-details" />}>
                                <Grid container alignItems="center" spacing={2} alignContent="flex-start">
                                    <Grid item xs={6}>
                                        <TextField
                                            select
                                            fullWidth
                                            value={container.type_id || ''}
                                            label={<FormattedMessage id="container-type" values={{ indicator: <RequiredIndicator /> }} />}
                                            onChange={(e) => setContainer((prev) => ({ ...prev, type_id: Number(e.target.value) }))}
                                            InputLabelProps={{ shrink: true }}
                                        >
                                            {containerTypes.map((type) => (
                                                <MenuItem key={type.id} value={type.id}>
                                                    <FormattedMessage id={type.name} defaultMessage={type.name} />
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>

                                    {isExamChapter && (
                                        <>
                                            <Grid item xs={6}>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    value={container.chapter_id || ''}
                                                    label={
                                                        <FormattedMessage id="chapter-type" values={{ indicator: <RequiredIndicator /> }} />
                                                    }
                                                    onChange={(e) => setContainer({ ...container, chapter_id: e.target.value })}
                                                    InputLabelProps={{ shrink: true }}
                                                >
                                                    {chapterTypes.map((type) => (
                                                        <MenuItem key={type.id} value={type.id}>
                                                            <FormattedMessage id={type.name} />
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>
                                        </>
                                    )}

                                    <Grid item xs={6}>
                                        {container.type_id == 10 || container.type_id == 11 ? (
                                            <>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    value={container.chapter_id || ''}
                                                    label={
                                                        <FormattedMessage id="chapter-type" values={{ indicator: <RequiredIndicator /> }} />
                                                    }
                                                    onChange={(e) => setContainer({ ...container, chapter_id: e.target.value })}
                                                    InputLabelProps={{ shrink: true }}
                                                >
                                                    {chapterTypes.map((type) => (
                                                        <MenuItem key={type.id} value={type.id}>
                                                            <FormattedMessage id={type.name} />
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </>
                                        ) : (
                                            <>
                                                <TextField
                                                    fullWidth
                                                    value={container.title}
                                                    label={
                                                        <FormattedMessage
                                                            id="container-name"
                                                            values={{ indicator: <RequiredIndicator /> }}
                                                        />
                                                    }
                                                    onChange={(e) => setContainer({ ...container, title: e.target.value.trimStart() })}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </>
                                        )}
                                    </Grid>

                                    <Grid item xs={6}>
                                        {container.type_id === 10 || container.type_id === 11 ? (
                                            <>
                                                <TextField
                                                    fullWidth
                                                    value={container.title}
                                                    label={
                                                        <FormattedMessage
                                                            id="container-name"
                                                            values={{ indicator: <RequiredIndicator /> }}
                                                        />
                                                    }
                                                    onChange={(e) => setContainer({ ...container, title: e.target.value.trimStart() })}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <TextField
                                                    fullWidth
                                                    value={container.display_name}
                                                    label={
                                                        <FormattedMessage id="display-name" values={{ indicator: <RequiredIndicator /> }} />
                                                    }
                                                    onChange={(e) =>
                                                        setContainer({ ...container, display_name: e.target.value.trimStart() })
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </>
                                        )}
                                        {/* <TextField
                                            fullWidth
                                            value={container.display_name}
                                            label={<FormattedMessage id="display-name" values={{ indicator: <RequiredIndicator /> }} />}
                                            onChange={(e) => setContainer({ ...container, display_name: e.target.value })}
                                            InputLabelProps={{ shrink: true }}
                                        /> */}
                                    </Grid>
                                    {/* {isExamChapter && (
                                        <>
                                            <Grid item xs={6}>
                                                <TextField
                                                    fullWidth
                                                    type="number"
                                                    label={<FormattedMessage id="m-score" />}
                                                    onChange={(e) => {
                                                        setContainer({ ...container, m_score: Number(e.target.value) });
                                                    }}
                                                    inputProps={{ min: '0' }} // This prevents entering negative values
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    fullWidth
                                                    type="number"
                                                    label={<FormattedMessage id="n-score" />}
                                                    onChange={(e) => {
                                                        setContainer({ ...container, n_score: Number(e.target.value) });
                                                    }}
                                                    inputProps={{ min: '0' }} // This prevents entering negative values
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>
                                        </>
                                    )} */}

                                    {!isExamChapter && (
                                        <>
                                            {container.type_id == 10 || container.type_id === 11 ? (
                                                <>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            fullWidth
                                                            value={container.display_name}
                                                            label={
                                                                <FormattedMessage
                                                                    id="display-name"
                                                                    values={{ indicator: <RequiredIndicator /> }}
                                                                />
                                                            }
                                                            onChange={(e) =>
                                                                setContainer({ ...container, display_name: e.target.value.trimStart() })
                                                            }
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    </Grid>
                                                </>
                                            ) : (
                                                <>
                                                    <Grid item xs={2}>
                                                        {/* <TextField
                                                    disabled={disableInSingleQuestion}
                                                    fullWidth
                                                    value={container.time || ''}
                                                    label={<FormattedMessage id="time" />}
                                                    onChange={(e) => setContainer({ ...container, time: e.target.value })}
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={
                                                        disableInSingleQuestion
                                                            ? {
                                                                  '.MuiOutlinedInput-notchedOutline': {
                                                                      borderColor: '#E6EAEF !important',
                                                                      background: '#FDFEFF'
                                                                  }
                                                              }
                                                            : {}
                                                    }
                                                /> */}
                                                        <FormControl>
                                                            <FormLabel id="type-buttons-group-label" sx={{ mt: 2.5 }}>
                                                                <FormattedMessage id="time" />
                                                            </FormLabel>
                                                            <TextMask
                                                                disabled={disableInSingleQuestion}
                                                                mask={timeMask}
                                                                guide={false} // Set to true if you want to show placeholders while typing
                                                                value={container.time || '00:00:00'}
                                                                onChange={(e) => setContainer({ ...container, time: e.target.value })}
                                                                style={{
                                                                    borderColor: disableInSingleQuestion ? '#808080' : '#fafafa',
                                                                    background: disableInSingleQuestion ? '#808080' : '#fafafa',
                                                                    borderRadius: '8px',
                                                                    marginTop: '12px',
                                                                    width: '70px',
                                                                    height: '30px'
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                </>
                                            )}

                                            {container.type_id == 10 || container.type_id === 11 ? (
                                                <></>
                                            ) : (
                                                <>
                                                    <Grid item xs={4}>
                                                        <FormControl>
                                                            <FormLabel id="type-buttons-group-label" sx={{ mt: 2.5 }}>
                                                                <FormattedMessage
                                                                    id="practice-types"
                                                                    values={{ indicator: <RequiredIndicator /> }}
                                                                />
                                                            </FormLabel>
                                                            <Box display="flex" alignItems="center">
                                                                <RadioGroup
                                                                    row
                                                                    aria-labelledby="type-buttons-group-label"
                                                                    name="row-radio-buttons-group"
                                                                    value={container.practice_type}
                                                                    onChange={handlePracticeTypeChange}
                                                                >
                                                                    <FormControlLabel
                                                                        value="arranged"
                                                                        control={<Radio />}
                                                                        label={<FormattedMessage id="arranged" />}
                                                                    />
                                                                    {container.type_id == 4 ? (
                                                                        <></>
                                                                    ) : (
                                                                        <>
                                                                            {' '}
                                                                            <FormControlLabel
                                                                                value="random"
                                                                                control={<Radio />}
                                                                                label={<FormattedMessage id="random" />}
                                                                            />
                                                                        </>
                                                                    )}
                                                                </RadioGroup>
                                                                <IconButton
                                                                    color="primary"
                                                                    sx={{ alignSelf: 'flex-end' }}
                                                                    disabled={
                                                                        !isRandom ||
                                                                        (container.practice_type == 'random' &&
                                                                            !container.product_category_id)
                                                                    }
                                                                    onClick={() => setOpenRandom(true)}
                                                                >
                                                                    <SettingsIcon />
                                                                </IconButton>
                                                            </Box>
                                                        </FormControl>
                                                    </Grid>
                                                </>
                                            )}
                                        </>
                                    )}

                                    {isRandom && (
                                        <Grid item xs={12}>
                                            <Box>{randomSettings?.length > 0 && <RandomSettingsBox randomSettings={randomSettings} />}</Box>
                                        </Grid>
                                    )}
                                </Grid>
                            </MainCard>
                        </Grid>
                        <Grid item xs={12}>
                            <MainCard
                                title={
                                    container.type_id === 11 ? (
                                        <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
                                            <Grid item>
                                                <FormattedMessage id="tags" />
                                            </Grid>
                                            <Grid item md={6}>
                                                <Autocomplete
                                                    multiple
                                                    options={levelTags}
                                                    getOptionLabel={(option) => option.name}
                                                    value={container.level_tags}
                                                    onChange={(event, newValue) =>
                                                        setContainer((prev) => ({ ...prev, level_tags: newValue }))
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            label={
                                                                <FormattedMessage
                                                                    id="tagging-for-trampling"
                                                                    values={{ indicator: <RequiredIndicator /> }}
                                                                />
                                                            }
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>
                                    ) : (
                                        <FormattedMessage id="tags" />
                                    )
                                }
                            >
                                <Grid container spacing={2}>
                                    <Grid item md={6}>
                                        <TextField
                                            disabled={disabledProductCategory}
                                            select
                                            fullWidth
                                            label={
                                                <FormattedMessage
                                                    id="product-category-title"
                                                    values={{ indicator: <RequiredIndicator /> }}
                                                />
                                            }
                                            InputLabelProps={{ shrink: true }}
                                            SelectProps={{
                                                IconComponent: (iconProps) =>
                                                    container.product_category_id && !disabledProductCategory ? (
                                                        <IconButton
                                                            onClick={() => setContainer({ ...container, product_category_id: null })}
                                                            hidden={!container.product_category_id}
                                                        >
                                                            <HighlightOff />
                                                        </IconButton>
                                                    ) : (
                                                        <ArrowDropDown {...iconProps} />
                                                    )
                                            }}
                                            value={container.product_category_id ?? ''}
                                            onChange={(e) => {
                                                if (Number(e.target.value) !== container.product_category_id)
                                                    setContainer({
                                                        ...container,
                                                        product_category_id: Number(e.target.value)
                                                    });
                                                setContainer((prevState) => ({
                                                    ...prevState,
                                                    tags: []
                                                    // tags: {
                                                    //     main: [],
                                                    //     subtheme: []
                                                    // }
                                                }));
                                            }}
                                        >
                                            {productCategories.map((productCat) => (
                                                <MenuItem key={productCat.id} value={productCat.id}>
                                                    {productCat.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item md={6}>
                                        <Autocomplete
                                            multiple
                                            options={tags}
                                            getOptionLabel={(option) => option.name}
                                            // value={container.tags.main}
                                            // onChange={(event, newValue) =>
                                            //     setContainer((prev) => ({ ...prev, tags: { ...prev.tags, main: newValue } }))
                                            // }
                                            value={container.tags}
                                            onChange={(event, newValue) => setContainer((prev) => ({ ...prev, tags: newValue }))}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    label={
                                                        <FormattedMessage
                                                            id="tag-without-indicator"
                                                            values={{ indicator: <RequiredIndicator /> }}
                                                        />
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )}
                                            fullWidth
                                        />
                                    </Grid>
                                    {/* <Grid item md={6}>
                                        <Autocomplete
                                            multiple
                                            options={secondaryTags}
                                            getOptionLabel={(option) => option.name}
                                            value={container.tags.subtheme}
                                            onChange={(event, newValue) =>
                                                setContainer((prev) => ({ ...prev, tags: { ...prev.tags, subtheme: newValue } }))
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    label={<FormattedMessage id="ancestor-tag-list" />}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )}
                                            fullWidth
                                        />
                                    </Grid> */}
                                </Grid>
                            </MainCard>
                        </Grid>
                        {isOnlineTest && (
                            <Grid item xs={12}>
                                <MainCard title={<FormattedMessage id="score-calculation" />}>
                                    <Grid container spacing={2}>
                                        <Grid item md={3}>
                                            <TextField
                                                fullWidth
                                                value={container.beginner_level_of_student}
                                                label={<FormattedMessage id="beginer-student-level" />}
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    // Regex to allow only numbers up to 2 digits and one optional decimal point
                                                    const isValid = /^(?:\d{1,2}(?:\.\d{0,1})?)?$/.test(inputValue);
                                                    if (isValid) {
                                                        setContainer({ ...container, beginner_level_of_student: Number(inputValue) });
                                                    }
                                                }}
                                                error={!/^(?:\d{1,2}(?:\.\d{0,1})?)?$/.test(String(container.beginner_level_of_student))}
                                                helperText={
                                                    !/^(?:\d{1,2}(?:\.\d{0,1})?)?$/.test(String(container.beginner_level_of_student))
                                                        ? 'Please enter a number up to 2 digits with an optional decimal point'
                                                        : null
                                                }
                                                inputProps={{
                                                    inputMode: 'decimal', // This will show numeric keyboard on mobile devices
                                                    pattern: '^(?:\\d{1,2}(?:\\.\\d{0,1})?)?$' // HTML5 pattern for validation
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                        <Grid item md={3}>
                                            <TextField
                                                fullWidth
                                                value={container.change_factor}
                                                label={<FormattedMessage id="change-factor" />}
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    // Regex to allow only numbers up to 2 digits and one optional decimal point
                                                    const isValid = /^(?:\d{1,2}(?:\.\d{0,1})?)?$/.test(inputValue);
                                                    if (isValid) {
                                                        setContainer({ ...container, change_factor: Number(inputValue) });
                                                    }
                                                }}
                                                error={!/^(?:\d{1,2}(?:\.\d{0,1})?)?$/.test(String(container.change_factor))}
                                                helperText={
                                                    !/^(?:\d{1,2}(?:\.\d{0,1})?)?$/.test(String(container.change_factor))
                                                        ? 'Please enter a number up to 2 digits with an optional decimal point'
                                                        : null
                                                }
                                                inputProps={{
                                                    inputMode: 'decimal', // This will show numeric keyboard on mobile devices
                                                    pattern: '^(?:\\d{1,2}(?:\\.\\d{0,1})?)?$' // HTML5 pattern for validation
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                        <Grid item md={3}>
                                            <TextField
                                                fullWidth
                                                value={container.m_score}
                                                label={<FormattedMessage id="conversion-multiper" />}
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    // Regex to allow only numbers up to 2 digits and one optional decimal point
                                                    const isValid = /^(?:\d{1,2}(?:\.\d{0,1})?)?$/.test(inputValue);
                                                    if (isValid) {
                                                        setContainer({ ...container, m_score: Number(inputValue) });
                                                    }
                                                }}
                                                error={!/^(?:\d{1,2}(?:\.\d{0,1})?)?$/.test(String(container.m_score))}
                                                helperText={
                                                    !/^(?:\d{1,2}(?:\.\d{0,1})?)?$/.test(String(container.m_score))
                                                        ? 'Please enter a number up to 2 digits with an optional decimal point'
                                                        : null
                                                }
                                                inputProps={{
                                                    inputMode: 'decimal', // This will show numeric keyboard on mobile devices
                                                    pattern: '^(?:\\d{1,2}(?:\\.\\d{0,1})?)?$' // HTML5 pattern for validation
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                        <Grid item md={3}>
                                            <TextField
                                                fullWidth
                                                value={container.n_score}
                                                label={<FormattedMessage id="additional-conversation" />}
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    // Regex to allow only numbers up to 2 digits and one optional decimal point
                                                    const isValid = /^(?:\d{1,2}(?:\.\d{0,1})?)?$/.test(inputValue);
                                                    if (isValid) {
                                                        setContainer({ ...container, n_score: Number(inputValue) });
                                                    }
                                                }}
                                                error={!/^(?:\d{1,2}(?:\.\d{0,1})?)?$/.test(String(container.n_score))}
                                                helperText={
                                                    !/^(?:\d{1,2}(?:\.\d{0,1})?)?$/.test(String(container.n_score))
                                                        ? 'Please enter a number up to 2 digits with an optional decimal point'
                                                        : null
                                                }
                                                inputProps={{
                                                    inputMode: 'decimal', // This will show numeric keyboard on mobile devices
                                                    pattern: '^(?:\\d{1,2}(?:\\.\\d{0,1})?)?$' // HTML5 pattern for validation
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                        {/* <Grid item md={6}>
                                         <Autocomplete
                                             multiple
                                             options={secondaryTags}
                                             getOptionLabel={(option) => option.name}
                                             value={container.tags.subtheme}
                                             onChange={(event, newValue) =>
                                                 setContainer((prev) => ({ ...prev, tags: { ...prev.tags, subtheme: newValue } }))
                                             }
                                             renderInput={(params) => (
                                                 <TextField
                                                     {...params}
                                                     variant="outlined"
                                                     label={<FormattedMessage id="ancestor-tag-list" />}
                                                     InputLabelProps={{ shrink: true }}
                                                 />
                                             )}
                                             fullWidth
                                         />
                                     </Grid> */}
                                    </Grid>
                                </MainCard>
                            </Grid>
                        )}
                    </Grid>

                    <Grid item container md={6} spacing={3} alignContent="flex-start">
                        <Grid item xs={12}>
                            <MainCard
                                title={<FormattedMessage id="choose-objects-for-container" />}
                                secondary={
                                    <LabelStyle disabled={isRandom} sx={{ pt: 1, pb: 0, cursor: isRandom ? 'default' : 'pointer' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <IconButton
                                                    onClick={() => {
                                                        !isRandom && handleOptionChange();
                                                    }}
                                                >
                                                    <AddCircleOutline fontSize="small" sx={{ position: 'relative', color: '#7A49B9' }} />
                                                </IconButton>

                                                <FormattedMessage id="add-object" />
                                            </Box>
                                            {isOnlineTest && (
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <Checkbox
                                                        onChange={handleChangeCheckBox}
                                                        checked={isSetCondition}
                                                        sx={{ color: '#7A49B9' }}
                                                        style={{ color: '#7A49B9' }} // Change the color to green or any other color you prefer
                                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                                    />
                                                    <FormattedMessage id="enable-continuation-contidition" />
                                                </Box>
                                            )}
                                        </Box>
                                    </LabelStyle>
                                }
                                contentSX={{
                                    p: 0,
                                    '&:last-child': {
                                        paddingBottom: 0
                                    }
                                }}
                            >
                                {/* eslint-disable no-nested-ternary */}
                                {objects.length === 0 ? (
                                    <Box sx={{ paddingY: 6.25 }}>
                                        <NoObjectMessage informativeMessage="no-object-message" actionMessage="no-object-action-message" />
                                    </Box>
                                ) : isOnlineTest ? (
                                    objectSectionOnlineTest()
                                ) : (
                                    objectSection()
                                )}
                            </MainCard>
                        </Grid>
                    </Grid>
                </Grid>
                <Stack direction="row" marginTop={11} justifyContent="space-between">
                    <ButtonIconStyle
                        color="secondary"
                        onClick={() => navigate('/containers')}
                        variant="outlined"
                        startIcon={<ArrowForward />}
                    >
                        <FormattedMessage id="back" />
                    </ButtonIconStyle>
                    <Box sx={{ display: 'flex', gap: '30px' }}>
                        {container.type_id == 10 ? (
                            <>
                                <Stack maxWidth={130} spacing={2.5}>
                                    <Button variant="outlined" onClick={() => handleOnlinetestPreview()}>
                                        <FormattedMessage id="preview-online-test" />
                                    </Button>
                                </Stack>
                            </>
                        ) : null}

                        <Stack maxWidth={130} spacing={2.5}>
                            {
                                // eslint-disable-next-line no-nested-ternary
                                totalScore === 0 ? null : totalScore === 100 ? (
                                    <Typography color="success.main" sx={{ fontSize: 12 }}>
                                        <Stack direction="row">
                                            <CheckRounded sx={{ fontSize: 16, mr: 0.6 }} />
                                            <FormattedMessage id="test-sum-100" />
                                        </Stack>
                                    </Typography>
                                ) : (
                                    <Typography color="#D84315" sx={{ fontSize: 12 }}>
                                        <Stack direction="row">
                                            <CloseRounded sx={{ fontSize: 16, mr: 0.6 }} />
                                            <FormattedMessage id="test-sum-amount" values={{ score: totalScore }} />
                                        </Stack>
                                    </Typography>
                                )
                            }
                            <Button disabled={disabledSave} onClick={submitHandler} variant="contained" color="secondary">
                                {id ? <FormattedMessage id="updating" /> : <FormattedMessage id="save" />}
                            </Button>
                            {/* <Button variant="contained" color="secondary">
                            {id ? <FormattedMessage id="updating" /> : <FormattedMessage id="save" />}
                        </Button> */}
                        </Stack>
                    </Box>
                </Stack>
            </MainCard>
            <GlobalDrawer
                open={openRandom}
                onClose={() => setOpenRandom(false)}
                anchor="left"
                Component={
                    <AddObject
                        onClose={() => setOpenRandom(false)}
                        availabeFilters={requestParams.filters}
                        setFilters={(settings) => setRandomSettings(settings)}
                        randomSettings={randomSettings}
                    />
                }
            />

            <GlobalDialog
                onClose={() => setOpenAdd(false)}
                open={openAdd}
                Component={
                    <ObjectSelect
                        onClose={() => setOpenAdd(false)}
                        setObjects={setObjects}
                        existingObjects={objects}
                        restrictToType={container.type_id}
                        // restrictToProducts={product?.map((p: any) => p.id)}
                        restrictToProductCategory={container.product_category_id || 0}
                    />
                }
            />
            <GlobalDialog
                onClose={() => setOpenPreview(false)}
                open={openPreview}
                Component={<Preview onClose={() => setOpenPreview(false)} itemId={currentId} previewType={previewType} />}
            />
            {/* <GlobalDialog
                onClose={() => setOpenOnlinetestPreview(false)}
                open={openOnlineTestPreview}
                Component={<AddPreviewOnlineTest onClose={() => setOpenOnlinetestPreview(false)} />}
            /> */}

            <AddContainerDialog
                open={open}
                onClose={() => {
                    setOpen(false);
                    setObjects([]);
                    setExampoint([]);
                    setRandomSettings([]);
                }}
                onNo={() => {
                    setOpen(false);
                    setContainer({ ...container, practice_type: 'arranged' });
                }}
                content={
                    <Typography>
                        <FormattedMessage id="note-Choosing-Random-Practice" />
                    </Typography>
                }
            />
        </Box>
    );
}

export default AddContainer;
